import { ENVIRONMENT_TYPE } from '../../constants/main';

export interface FinanceWidgetProps {
    registerRenderCb: (cb: () => void) => void;
    generatedIndex?: number;
}

// @NOTE to be filled with the product code ‘SME’ in case of Summit’s platform
export const SITE_CODE = 'SME';

export enum CLIENT_TYPE {
    INDIVIDUAL = 'P',
    COMPANY = 'E',
    EMPLOYEE = 'COLL',
}
export const LOADING_WEIGHT = 3;

export enum JOURNEY_TYPE {
    B2C = 'ACVNR',
    B2C_STOCK = 'AVNSR',
    B2B = 'ACVNRPRO',
    B2B_STOCK = 'AVNSRPRO',
}

export const PROMO_CODE_CUSTOMER_TYPE_MAPPING: any = {
    B2C: CLIENT_TYPE.INDIVIDUAL,
    B2B: CLIENT_TYPE.COMPANY,
    B2E: CLIENT_TYPE.EMPLOYEE,
};

export const CUSTOMER_TYPE_MAPPING: any = {
    [ENVIRONMENT_TYPE.B2C]: CLIENT_TYPE.INDIVIDUAL,
    [ENVIRONMENT_TYPE.B2B]: CLIENT_TYPE.COMPANY,
    [ENVIRONMENT_TYPE.B2E]: CLIENT_TYPE.EMPLOYEE,
};

export const WIDGET_V1_ID = 'widget-1';
export const WIDGET_V2_ID = 'widget-2';